import React from 'react';
import { BookOpen, Calendar, Layers, FolderKanban, Heart, Users, FileCheck, Library } from 'lucide-react';
export function KitContents() {
  const items = [{
    icon: BookOpen,
    title: 'Fundamentación y Organización del Área',
    desc: 'Enfoque pedagógico y estructura anual lista para presentar.'
  }, {
    icon: Calendar,
    title: 'Planificación Anual Editable',
    desc: 'Contenidos organizados por trimestre, objetivos y criterios de evaluación.'
  }, {
    icon: Layers,
    title: 'Secuencias Didácticas Completas',
    desc: 'Introducción a la Psicología, Escuelas Psicológicas, Procesos Psicológicos, Desarrollo e Identidad. Con actividades y evaluaciones incluidas.'
  }, {
    icon: FolderKanban,
    title: 'Proyecto Integrador Anual',
    desc: 'Propuesta completa para integrar conocimientos.'
  }, {
    icon: Heart,
    title: 'Educación Emocional en Secundaria',
    desc: 'Recursos prácticos para trabajar ansiedad, regulación emocional y adolescencia.'
  }, {
    icon: Users,
    title: 'Banco de 40 Dinámicas Psicológicas para el Aula',
    desc: 'Actividades grupales para fomentar la participación.'
  }, {
    icon: FileCheck,
    title: 'Instrumentos de Evaluación y Rúbricas',
    desc: 'Herramientas claras para evaluar el progreso.'
  }, {
    icon: Library,
    title: 'Material Complementario y Bibliografía',
    desc: 'Recursos extra para enriquecer tus clases.'
  }];
  return <section className="bg-white py-6 md:py-8 px-4" data-id="element-117">
      <div className="max-w-5xl mx-auto" data-id="element-118">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-6" data-id="element-119">
          ¿QUÉ INCLUYE EL KIT COMPLETO PSICOLOGÍA LISTA?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-120">
          {items.map((item, index) => <div key={index} className="flex gap-3 p-4 bg-gray-50 rounded-xl border border-gray-100 hover:shadow-md transition-shadow" data-id="element-121">
              <div className="flex-shrink-0" data-id="element-122">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-bold text-xl" data-id="element-123">
                  {index + 1}
                </div>
              </div>
              <div data-id="element-124">
                <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-125">
                  {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-126">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}